import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-200 font-medium mb-2" }, " My Pending Rewards ", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-xl font-medium truncate flex items-center"
}
const _hoisted_3 = { class: "truncate flex items-center pb-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createBlock(_component_BalCard, null, {
    default: _withCtx(() => [
      _hoisted_1,
      (_ctx.hasEmbrRewards)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.fNum(_ctx.pendingEmbr, 'token_fixed')) + " MOND ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.fNum(_ctx.pendingEmbrValue, 'usd')), 1),
      _createVNode(_component_BalBtn, {
        label: "Harvest",
        block: "",
        color: "gradient",
        disabled: _ctx.pendingEmbr <= 0,
        loading: _ctx.harvesting,
        onClick: _withModifiers(_ctx.harvestRewards, ["prevent"])
      }, null, 8, ["disabled", "loading", "onClick"])
    ]),
    _: 1
  }))
}